/*    
<summary>
  This functional component "ChangeThemeSettings" defines the props like theme to be selected for user.
  Developer:Pratiksha Sharma, Created Date:09-June-2025
</summary>
<returns>Returns JSX</returns>
*/
import React from "react";

import { FormattedMessage } from "react-intl";
import ChangeThemeSettingsForm from "../forms/add-edit-theme-settings-form";

interface IProps {
  id: number;
}

const ChangeThemeSettings = (props: IProps) => {
  const savedTheme = localStorage.getItem("lizera_theme") || "0";
  let initialValues = {
    theme: savedTheme, // Default theme value
  };
  return (
    <React.Fragment>
      <div className="container-fluid mt-4 p-0">
        <div className="row align-items-center justify-content-center">
          <div className="col-md-7 col-lg-6 col-xl-4 col-xxl-3 col-12">
            <div className="card">
              <div className="card-header p-3">
                <h3 className="card-title mb-0">
                  <FormattedMessage id="set_theme_color" />
                </h3>
              </div>
              <div className="card-body">
                <ChangeThemeSettingsForm initialValues={initialValues} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ChangeThemeSettings;
